import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";


export default class PageGeneric extends PageCommon {
	constructor() {
		super();
	}
	init( $data ) {
		super.init($data );
		this.showPreloader(false);
		Pqp.trace("PageGeneric - Hello world");

		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
	}


}

